// extracted by mini-css-extract-plugin
export default {"menuContainer":"Menu-MenuDropdown-module__menuContainer--IkYcb","defaultWidth":"Menu-MenuDropdown-module__defaultWidth--QiMRw"};